import { useMyMatchHistory } from '@tark/shared/hooks';

import { useNavigate } from 'react-router-dom';

import { MatchLedger } from '../features/matches/MatchLedger';

export default function HomeRecentPlay() {

  const history = useMyMatchHistory();

  const navigate = useNavigate();

  const denied = [401,403,404,409].includes((history.error as {response?:{status?:number}})?.response?.status ?? 0);

  const matches = [];
  let remaining = 3;
  for (const match of denied ? [] : history.data?.pages[0]?.matches ?? []) {
    if (!remaining) break;
    if (match.scorecards?.length) {
      const cards=match.scorecards.filter(card=>card.viewerParticipated).slice(0,remaining);
      if(cards.length){matches.push({...match,scorecards:cards});remaining-=cards.length;}
    } else {matches.push(match);remaining--;}
  }

  return <section className="tk-panel p-4" aria-label="Recent play"><div className="flex items-center justify-between gap-2"><h2>Recent play</h2><button className="text-xs font-semibold text-primary" onClick={() => navigate('/play')}>All matches</button></div>

    {history.isLoading ? <p role="status" className="mt-3 text-sm text-text-muted">Loading your games…</p> : history.isError ? <button className="mt-3 text-primary" onClick={() => void history.refetch()}>Retry recent play</button> : matches.length ?

      <MatchLedger matches={matches} showSquad onOpen={(match,ordinal) => navigate(`/play/matches/${encodeURIComponent(match.matchId)}${ordinal ? `?scorecard=${ordinal}` : ''}`, {state:{from:'/welcome?mode=community'}})} /> : <p className="mt-3 text-sm text-text-muted">No recorded games yet.</p>}

  </section>;

}

